<template>
  <b-container style="color:white;min-width:100%;border-top-left-radius:15px;border-top-right-radius:15px;background-color:black;padding:30px;;">
    <b-row>
      <b-col sm class="mb-4">
        <h4>Enjoying {{ productName }}?</h4>
        <a href="https://www.producthunt.com/posts/lists-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-lists-2" target="_blank"><img class="mt-1" src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=167011&theme=dark" alt="Lists - Make lists... attendance, gratitude, books, and more! | Product Hunt Embed" style="width: 250px; height: 54px;" width="250px" height="54px" /></a>
      </b-col>
      <b-col sm class="mb-4">
        <h4>Cabinet Apps</h4>
        <p>Cabinet Apps are secured by the blockchain and protect user privacy by default. Try out the other apps!</p>
        <div style="display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;">
          <div v-for="app in apps" :key="app.id" style="margin-right: 10px;margin-bottom:10px;">
            <a :href="app.url" v-b-tooltip.hover :title="app.desc">
              <b-img-lazy 
                :src="app.image" 
                style="width:75px;border-radius:15px;border:1px solid #303030"
              ></b-img-lazy>
            </a>
          </div>
        </div>
        
      </b-col>
      <b-col sm class="mb-4">
        <h4>Contact Us</h4>
        <p>Questions? Suggestions? Want to talk? Reach out at <a href="mailto:apps@cabinetapps.com">apps@cabinetapps.com</a>.</p>
      </b-col>
    </b-row>
  </b-container> 
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      productName: 'Maps',
      apps: [
        {
          id: 0,
          name: 'Lists',
          url: 'https://lists.cabinet.app',
          image: 'https://i.ibb.co/61rbTKL/Lists-Logo-Sq.png',
          desc: 'Create decentralized lists for any purpose'
        },
        {
          id: 1,
          name: 'Culinary',
          url: 'https://culinary.cabinetapps.com',
          image: 'https://i.ibb.co/j8cWZt3/culinary-icn.png',
          desc: 'Store and share decentralized recipes'
        },
        {
          id: 2,
          name: 'Codelets',
          url: 'https://block.codelets.net',
          image: 'https://i.ibb.co/c1zxPkL/code-sq.png',
          desc: 'Create and share decentralized code snippets'
        },
        {
          id: 3,
          name: 'Maps',
          url: 'https://cabinetmaps.com',
          image: 'https://i.ibb.co/QPZ7pCp/maps-logo.png',
          desc: 'Create and share maps for your personal use, events, or business'
        },
        {
          id: 4,
          name: "List O'Links",
          url: 'https://lists.cabinet.app',
          image: 'https://i.ibb.co/wsLDQ8d/ll-logo-share.png',
          desc: 'Store and share lists of web links, articles, videos, tweets, etc.'
        },
      ]
    }
  }
}
  
</script>